import * as React from "react"

function SvgButtonPlay(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 100 100"
      {...props}
    >
      <path
        fill="currentColor"
        d="M50 0C22.387 0 0 22.387 0 50c0 27.612 22.387 50 50 50 27.612 0 50-22.388 50-50C99.97 22.4 77.6.03 50 0zm20.117 53.725L39.362 69.1a4.166 4.166 0 01-6.029-3.725V34.617a4.168 4.168 0 016.025-3.73L70.121 46.25a4.168 4.168 0 01-.004 7.47v.005z"
      />
    </svg>
  )
}

export default SvgButtonPlay
